import { useEffect, useState } from "react";
import axios from "axios";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Typography,
  TablePagination,
} from "@mui/material";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./TankLevelReports.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

export default function TankLevelReports() {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [rangeType, setRangeType] = useState("daily");

  const [reportData, setReportData] = useState([]);
  const [siteName, setSiteName] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [deviceName, setDeviceName] = useState("");

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");
  const customerId = localStorage.getItem("customer_id");
  const customerName = localStorage.getItem("customer_name");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  // ===========================
  // FETCH Customers
  // ===========================



  useEffect(() => {
    const fetchCustomers = async () => {

        // ✅ Customer Admin
    if (role === "CA" || role === "SE" || role === "DC") {
      setSelectedCustomer(customerId);

      // Optional (used for PDF export)
      setCustomers([
        {
          id: customerId,
          name: customerName || "Customer",
        },
      ]);

      return;
    }


      try {
        const res = await axios.get(`${API_URL}/api/get_customers/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        const customerList = (res.data || []).map((c) => ({
          id: c.tb_customer_id,
          name: c.customer_name,
        }));

        setCustomers(customerList);

        // auto select first customer
        if (customerList.length > 0) {
          setSelectedCustomer(customerList[0].id);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };

    fetchCustomers();
  }, [role, customerId]);

  // ===========================
  // FETCH SITES
  // ===========================
  useEffect(() => {

    const fetchSites = async () => {
      if (!selectedCustomer) return;

      try {

        let siteData = [];

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        };

        // ✅ SUPERVISOR
        if (role === "S") {

          const response = await axios.get(
            `${API_URL}/api/supervisor_sites/${userId}/`,
            config
          );

          siteData = (response.data.sites || []).map((site) => ({
            asset_id: site.asset_id,
            site_id: site.site_id,
            name: site.name,
          }));
        }

        // ✅ SITE ENGINEER
        else if (role === "SE") {

          const response = await axios.get(
            `${API_URL}/api/engineer_sites/${userId}/`,
            config
          );

          siteData = (response.data.sites || []).map((site) => ({
            asset_id: site.asset_id,
            site_id: site.site_id,
            name: site.site_name,
          }));
        }

        // ✅ SUPER ADMIN / CUSTOMER
        else {

          const response = await axios({
            url: `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: {},
          });

          siteData = response.data.data || [];
        }

        setSites(siteData);

        // ✅ AUTO SELECT FIRST SITE
        if (siteData.length > 0) {
          setSelectedSite(siteData[0].asset_id);
        }

      } catch (error) {

        console.error("Error fetching sites:", error);

      }
    };

    if (selectedCustomer || userId) {
      fetchSites();
    }

  }, [selectedCustomer, token, role, userId]);

  useEffect(() => {
    setSelectedSite("");
    setSites([]);
  }, [selectedCustomer]);

  // useEffect(() => {
  //   const fetchSites = async () => {
  //     try {
  //       const response = await axios({
  //         url: `${API_URL}/api/get_customer_sites/${customerId}/`,
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         data: {},
  //       });

  //       const siteData = response.data.data || [];

  //       setSites(siteData);

  //       // AUTO SELECT FIRST SITE
  //       if (siteData.length > 0) {
  //         setSelectedSite(siteData[0].asset_id);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching sites:", error);
  //     }
  //   };

  //   if (customerId) {
  //     fetchSites();
  //   }
  // }, [customerId, token]);

  // ===========================
  // FETCH REPORT
  // ===========================
  // ===========================
  // FETCH REPORT
  // ===========================
  useEffect(() => {
    const fetchTankReport = async () => {
      if (!selectedSite) return;

      setLoading(true);

      try {
        // =====================================
        // STEP 1: GET SITE DEVICES
        // =====================================
        const deviceRes = await axios.get(
          `${API_URL}/api/site_devices/${selectedSite}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );

        const siteDevices = deviceRes.data.devices || [];

        // NO DEVICE FOUND
        if (siteDevices.length === 0) {
          setReportData([]);
          setLoading(false);
          return;
        }

        // =====================================
        // STEP 2: TAKE FIRST DEVICE ID
        // =====================================
        // const deviceId = siteDevices[0].device_id;
        const selectedDevice = siteDevices[0];

        const deviceId = selectedDevice.device_id;

        setDeviceName(selectedDevice.device_name || "");

        // OPTIONAL
        console.log("Selected Device ID:", deviceId);

        // =====================================
        // STEP 3: FETCH TANK REPORT
        // =====================================
        const reportRes = await axios({
          url: `${API_URL}/api/get_tank_level_report/${deviceId}/?rangeType=${rangeType}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        });

        setReportData(reportRes.data.data || []);
        setSiteName(reportRes.data.site_selection || "");
      } catch (error) {
        console.error("Error fetching tank report:", error);
        setReportData([]);
      }

      setLoading(false);
    };

    fetchTankReport();
  }, [selectedSite, rangeType]);

  // ===========================
  // CSV EXPORT
  // ===========================
  const handleExportCSV = () => {

    const headers = [
      "Sr No",
      "Date Time",
      "Device Name",
      "Water Tank Level",
      "Diesel Tank Level",
    ];

    const rows = reportData.map((item) => [
      item.sr_no,
      item.date_time,
      deviceName,
      item.water_tank_level,
      item.diesel_tank_level,
    ]);
// const customerNameForExport =
//   role === "CA" || role === "SE"
//     ? localStorage.getItem("customer_name") || "Customer"
//     : customers.find((c) => c.id === selectedCustomer)?.name || "Customer";


const customerNameForExport =
  customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

    const csvContent = [
      // [`Customer Name:,${customerNameForExport}`],
        ...(role !== "CA" && role !== "SE" && role !== "DC"
    ? [[`Customer Name:,${customerNameForExport}`]]
    : []),
      [`Site Name:,${siteName}`],
      [`Report Type:,${rangeType}`],
      [],
      headers,
      ...rows,  
    ]
      .map((e) => e.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");
    link.href = encodeURI(csv);
    link.download = `${siteName}_tank_report.csv`;
    link.click();
  };

  // ===========================
  // PDF EXPORT
  // ===========================
  const handleExportPDF = () => {
    const doc = new jsPDF();
  //   const customerName =
  // role === "CA" || role === "SE"
  //   ? localStorage.getItem("customer_name") || "Customer"
  //   : customers.find((c) => c.id === selectedCustomer)?.name || "Customer";



  const customerName =
  customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

    doc.setFontSize(16);
    doc.text("Tank Level Report", 14, 12);

    doc.setFontSize(11);
    // doc.text(`Customer Name: ${customerName}`, 14, 18);
    // doc.text(`Site Name: ${siteName}`, 14, 26);
    // doc.text(`Report Type: ${rangeType}`, 14, 34);

    // autoTable(doc, {
    //   startY: 42,

    let y = 18;

if (role !== "CA" && role !== "SE" && role !== "DC") {
  doc.text(`Customer Name: ${customerName}`, 14, y);
  y += 8;
}

doc.text(`Site Name: ${siteName}`, 14, y);
y += 8;

doc.text(`Report Type: ${rangeType}`, 14, y);

autoTable(doc, {
  startY: y + 8,

      head: [
        [
          "Sr No",
          "Date Time",
          "Device Name",
          "Water Tank",
          "Diesel Tank",
        ],
      ],

      body: reportData.map((item) => [
        item.sr_no,
        item.date_time,
        deviceName,
        item.water_tank_level,
        item.diesel_tank_level,
      ]),
    });

    doc.save(`${customerName}_${siteName}_tank_report.pdf`);
  };

  return (
    <Box className="report-container">
      {/* TOP BAR */}
      <Box className="top-bar">
        {/* CUSTOMER DROPDOWN */}
      {role !== "CA" && role !== "SE" && role !== "Dc" && (
  <FormControl className="dropdown">
    <InputLabel>Select Customer</InputLabel>

    <Select
      value={selectedCustomer}
      label="Select Customer"
      onChange={(e) => setSelectedCustomer(e.target.value)}
    >
      {customers.map((c) => (
        <MenuItem key={c.id} value={c.id}>
          {c.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)}
        {/* SITE DROPDOWN */}
        <FormControl className="dropdown">
          <InputLabel>Select Site</InputLabel>

          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            {sites.map((site) => (
              <MenuItem key={site.site_id} value={site.asset_id}>
                {site.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* RANGE TYPE */}
        <FormControl className="dropdown">
          <InputLabel>Report Type</InputLabel>

          <Select
            value={rangeType}
            label="Report Type"
            onChange={(e) => setRangeType(e.target.value)}
          >
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
          </Select>
        </FormControl>

        {/* EXPORT BUTTONS */}
        <Box className="export-buttons">
          <Button className="btn-csv" onClick={handleExportCSV}>
            CSV
          </Button>

          <Button className="btn-pdf" onClick={handleExportPDF}>
            PDF
          </Button>
        </Box>
      </Box>

      {/* REPORT HEADER */}


      {/* TABLE */}
      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Date Time</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Water Tank Level</TableCell>
              <TableCell>Diesel Tank Level</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : reportData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            ) : (
              reportData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.sr_no}</TableCell>

                    <TableCell>{item.date_time}</TableCell>

                    <TableCell>{deviceName}</TableCell>

                    <TableCell>
                      <span
                        style={{
                          color:
                            item.water_tank_level === "0%"
                              ? "red"
                              : item.water_tank_level === "100%"
                                ? "green"
                                : "#d98b00",
                          fontWeight: "bold",
                        }}
                      >
                        {item.water_tank_level}
                      </span>
                    </TableCell>

                    <TableCell>
                      <span
                        style={{
                          color:
                            item.diesel_tank_level === "0%"
                              ? "red"
                              : item.diesel_tank_level === "100%"
                                ? "green"
                                : "#d98b00",
                          fontWeight: "bold",
                        }}
                      >
                        {item.diesel_tank_level}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
       
      </TableContainer>
       <TablePagination
          component="div"
          count={reportData.length}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}